import axios from 'axios'
import Settings from "../../settings.json";
const url = Settings.isNative ? Settings.frontlineArServer : "";

export class TableRequester {

    static async fetchTableData(path, query) {
        const result = await axios.post(`${url}/${path}`,query);
        return result.data;
    }
    static async editTableData(path, editedData) {
        const result = await axios.post(`${url}/${path}`,editedData);
        return result.data;
    }
    static async createTableData(path, newTableObject) {
        const result = await axios.post(`${url}/${path}`, newTableObject);
        return result.data;
    }
    static async deleteTableData(path, TableObject) {
        const result = await axios.post(`${url}/${path}`, TableObject);
        return result.data;
    }

}